/**
 * Schematic versions — list / get / diff / restore for committed
 * :SchematicVersion rows on a project.
 *
 * Mirrors ``backend/projects/router.py`` version sub-routes.
 */
import { env } from "@/env";
import apiClient from "@lib/axios";
import type {
  RestoreVersionResponse,
  SchematicVersion,
  VersionDiffResponse,
} from "@models/project";

export const versionsApi = {
  list: async (projectId: string): Promise<SchematicVersion[]> => {
    const { data } = await apiClient.get<SchematicVersion[]>(
      `/projects/${encodeURIComponent(projectId)}/versions`,
    );
    return data;
  },
  get: async (
    projectId: string,
    versionId: string,
  ): Promise<SchematicVersion> => {
    const { data } = await apiClient.get<SchematicVersion>(
      `/projects/${encodeURIComponent(projectId)}/versions/${encodeURIComponent(
        versionId,
      )}`,
    );
    return data;
  },
  diff: async (
    projectId: string,
    versionAId: string,
    versionBId: string,
  ): Promise<VersionDiffResponse> => {
    const { data } = await apiClient.get<VersionDiffResponse>(
      `/projects/${encodeURIComponent(projectId)}/versions/${encodeURIComponent(
        versionAId,
      )}/diff/${encodeURIComponent(versionBId)}`,
    );
    return data;
  },
  restore: async (
    projectId: string,
    versionId: string,
  ): Promise<RestoreVersionResponse> => {
    const { data } = await apiClient.post<RestoreVersionResponse>(
      `/projects/${encodeURIComponent(projectId)}/versions/${encodeURIComponent(
        versionId,
      )}/restore`,
    );
    return data;
  },
  downloadUrl: (projectId: string, versionId: string): string =>
    `${env.VITE_API_BASE_URL}/projects/${encodeURIComponent(
      projectId,
    )}/versions/${encodeURIComponent(versionId)}/download`,
};
